import * as React from 'react';
import styled from 'styled-components';
import { Page } from '../containers';

const StyledPage = styled(Page)`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: white;
  z-index: 10000;
  display: flex;
  flex-direction: column;
`;
const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  color: #454545;
  text-align: center;
`;
const Title = styled.div`
  font-size: 72px;
  margin-bottom: 30px;
  font-weight: bold;
`;
const Text = styled.div`
  font-size: 30px;
  margin-bottom: 60px;
`;
const IconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
const Icon = styled.img`
  width: 80px;
  height: 80px;
  margin: 0 20px;
`;

type Props = {};

const IENotSupportedMessage: React.SFC<Props> = () => (
  <StyledPage pageName={'IENotSupported'}>
    <ContentContainer>
      <Title>Your Browser is not supported</Title>
      <Text>To use this site please use Chrome or Firefox</Text>
      <IconsContainer>
        <Icon src="https://home-web.azureedge.net/home-web-resources/homepage/chrome.png" />
        <Icon src="https://home-web.azureedge.net/home-web-resources/homepage/ff.png" />
      </IconsContainer>
    </ContentContainer>
  </StyledPage>
);

export default IENotSupportedMessage;



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/IENotSupportedMessage/index.tsx